import { useMemo } from 'react'

import { Combobox, type ComboboxOption } from '@klear/ui/components/combobox'
import { Label } from '@klear/ui/components/label'
import { useTraders } from '@klear/ui/hooks/use-traders'
import toInteger from 'lodash/toInteger'
import toString from 'lodash/toString'

export type TraderComboboxProps = {
  value: number | null
  onChange: (traderId: number | null) => void
  label?: string | null
  disabled?: boolean
  className?: string
}

export function TraderCombobox({ value, onChange, label = 'Trader', disabled, className }: TraderComboboxProps) {
  const { traders } = useTraders()

  const options = useMemo<ComboboxOption[]>(
    () => traders?.map((trader) => ({ value: toString(trader.id), label: trader.name ?? toString(trader.id) })) ?? [],
    [traders]
  )

  return (
    <div className="space-y-2">
      {label != null && <Label className="text-sm font-medium">{label}</Label>}
      <Combobox
        options={options}
        value={value != null ? toString(value) : ''}
        onChange={(next: string) => onChange(next ? toInteger(next) : null)}
        disabled={disabled}
        triggerLabel="Select trader…"
        placeholder="Search traders…"
        className={className}
      />
    </div>
  )
}
